
import React, { useEffect, useState } from 'react'; // React is now imported
import {
  TextField,
  MenuItem,
  Button,
  Typography,
  Grid,
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import axios from 'axios';
import { CONFIG } from '../config';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Tabs, Tab, Paper } from "@mui/material";
import RiskRegisterFormForEvaluateSub from "./RiskRegisterFormForEvaluateSub";

const RiskRegisterFormForEvaluate = ({ dataForRegisterFormEval, globalCentreId, numbertoDisplay, rHName, tabDataArr}) => {

//   const selectedRiskHierarchy = hierarchyData.find((item) => item.id === selectedRiskHierarchyIdForRisk);
//   const selectedRegisterIdd = registerDetailId ? registerDetailId : selectedRegisteredId;
//   const selectedRegister = allRegister.find((item) => item.id === selectedRegisterIdd);
  //console.log(selectedRegister)
  //console.log(selectedRiskHierarchy);

  console.log(dataForRegisterFormEval);
  
  
  const [allEntityData, setAllEntityData] = useState([]);

  async function getEntityData() {
    if (CONFIG.SYSTEM_WITH_MENU_SYSTEM) {
      try {
        const entityList = await axios.get(`${CONFIG.MAIN_URL}/consolidatedCompanyEntity/filter?schoolId=${globalCentreId}`);
        console.log(entityList);
        
        const tmpEntityData = [];
        for (const item of entityList.data) {
            if (item.isActive && item.schoolId === globalCentreId){
                const basicEntity = item.basicEntityId;
                const basicentityList = await axios.get(`${CONFIG.MAIN_URL}/basicEntity/filter?schoolId=${globalCentreId}`); 
                const findBasicEntity = basicentityList.data.find(basic => basic.basicEntityId === basicEntity)
                const arrayData = {
                    entityId: item.entityId,
                    entityName: item.entityName,
                    isActive: item.isActive,
                    createdBy: item.createdBy,
                    centreId: item.schoolId,
                    lastModifiedBy: item.lastModifiedBy,
                    basicEntity : {
                      basicEntityId: findBasicEntity.basicEntityId,
                      entityName: findBasicEntity.entityName,
                      iamRole: findBasicEntity.iamRole,
                      forceIamRole: findBasicEntity.forceIamRole,
                    }

                };

                tmpEntityData.push(arrayData);
            }
        }
       
        console.log(tmpEntityData);
        var tmpEntityData1 = [];
        tmpEntityData.forEach((item, index)=>{
          if (item.isActive && item.centreId === globalCentreId){
                var be = item.basicEntity
                var forceIamRole = item.basicEntity.forceIamRole;
                var iamRole = item.basicEntity.iamRole;  
                var canTake = true;
                if ((iamRole === "parent") || (iamRole === "ADMIN" && forceIamRole === "ADMIN") || (iamRole === "supplier" && forceIamRole === "supplier") || (iamRole === "serviceprovider" && forceIamRole === "serviceprovider") || (iamRole === "volunteer" && forceIamRole === "volunteer")){
                  canTake = false;
                }
                if (canTake){
                  var arrayData = {}
                  arrayData["entityId"] = item.entityId;
                  arrayData["entityName"] = item.entityName;
                  tmpEntityData1.push(arrayData);
                }  
            }
        })
        console.log(tmpEntityData1);
        setAllEntityData(tmpEntityData1);
    } catch (error) {
        console.error("Error fetching entity list:", error);
    }
    }else{
    var data = '{allEntityList{ entityDataList{entityName,entityId,isActive,createdBy,lastModifiedBy,centreId,basicEntity{basicEntityId,entityName,iamRole,forceIamRole}}}}';
    axios(CONFIG.MAIN_URL + '/graphql', {
      method: 'post',
      headers: {
        'Content-Type': 'text/plain',
      },
      data: data,
    })
      .then(function (response) {
        var entityList = response.data.data.allEntityList.entityDataList;
        var tmpEntityData = [];
        entityList.forEach((item, index) => {
          if (item.isActive && item.centreId === globalCentreId){
            var be = item.basicEntity
            var forceIamRole = item.basicEntity.forceIamRole;
            var iamRole = item.basicEntity.iamRole;
            var canTake = true;
            if ((iamRole === "ADMIN" && forceIamRole === "ADMIN") || (iamRole === "supplier" && forceIamRole === "supplier") || (iamRole === "serviceprovider" && forceIamRole === "serviceprovider") || (iamRole === "volunteer" && forceIamRole === "volunteer")) {
              canTake = false;
            }
            if (canTake) {
              var arrayData = {};
              arrayData["entityId"] = item.entityId;
              arrayData["entityName"] = item.entityName;
              tmpEntityData.push(arrayData);
            }
          }
        })
        setAllEntityData(tmpEntityData);

      })
      .catch(function (error) {
        
      });
  }
  }

  useEffect (() => {
    getEntityData()

  },[])


  const formatDate = (date) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${year}-${month}-${day}`;
  };

  const uniqueEntityNames = Array.from(
    new Set(allEntityData.map((data) => data.entityName))
  ).filter((name) => name !== "superadmin");


  console.log(dataForRegisterFormEval?.riskHierarchy?.riskAdditionalData);
  
  const [formData, setFormData] = useState({
    riskReference: dataForRegisterFormEval?.riskHierarchy? dataForRegisterFormEval?.riskHierarchy?.riskAdditionalData?.generalInformation?.riskReference || "" : dataForRegisterFormEval?.riskAdditionalData?.generalInformation?.riskReference || "",
    riskCategory:  dataForRegisterFormEval?.riskHierarchy? dataForRegisterFormEval?.riskHierarchy?.riskAdditionalData?.generalInformation?.riskCategory || "" :  dataForRegisterFormEval?.riskAdditionalData?.generalInformation?.riskCategory || "",
    objectivesAffected: dataForRegisterFormEval?.riskHierarchy? dataForRegisterFormEval?.riskHierarchy?.riskAdditionalData?.generalInformation?.objectivesAffected  || "" : dataForRegisterFormEval?.riskAdditionalData?.generalInformation?.objectivesAffected  || "",
    likelihood: dataForRegisterFormEval?.riskHierarchy? dataForRegisterFormEval?.riskHierarchy?.riskAdditionalData?.assessment?.riskLikelihood  || "" : dataForRegisterFormEval?.riskAdditionalData?.assessment?.riskLikelihood  || "",
    impact: dataForRegisterFormEval?.riskHierarchy? dataForRegisterFormEval?.riskHierarchy?.riskAdditionalData?.assessment?.riskImpact  || "": dataForRegisterFormEval?.riskAdditionalData?.assessment?.riskImpact  || "",
    riskAppetite: dataForRegisterFormEval?.riskHierarchy? dataForRegisterFormEval?.riskHierarchy?.riskAdditionalData?.assessment?.riskAppetite  || "" : dataForRegisterFormEval?.riskAdditionalData?.assessment?.riskAppetite  || "",
    currentControls: dataForRegisterFormEval?.riskHierarchy? dataForRegisterFormEval?.riskHierarchy?.riskAdditionalData?.currentControls?.currentControls  || "" : dataForRegisterFormEval?.riskAdditionalData?.currentControls?.currentControls  || "",
    controlEffectiveness: dataForRegisterFormEval?.riskHierarchy?  dataForRegisterFormEval?.riskHierarchy?.riskAdditionalData?.currentControls?.controlEffectiveness  || "" : dataForRegisterFormEval?.riskAdditionalData?.currentControls?.controlEffectiveness  || "",
    mitigation: dataForRegisterFormEval?.riskHierarchy? dataForRegisterFormEval?.riskHierarchy?.riskAdditionalData?.mitigationActions?.mitigation  || "" : dataForRegisterFormEval?.riskAdditionalData?.mitigationActions?.mitigation  || "",
    actionOwner: dataForRegisterFormEval?.riskHierarchy? dataForRegisterFormEval?.riskHierarchy?.riskAdditionalData?.mitigationActions?.actionOwner  || "" : dataForRegisterFormEval?.riskAdditionalData?.mitigationActions?.actionOwner,
    targetCompletionDate: dataForRegisterFormEval?.riskHierarchy? dataForRegisterFormEval?.riskHierarchy?.riskAdditionalData?.mitigationActions?.targetCompletionDate  || "" : dataForRegisterFormEval?.riskAdditionalData?.mitigationActions?.targetCompletionDate  || "",
    status: dataForRegisterFormEval?.riskHierarchy? dataForRegisterFormEval?.riskHierarchy?.riskAdditionalData?.mitigationActions?.status  || "" : dataForRegisterFormEval?.riskAdditionalData?.mitigationActions?.status  || "",
    reviewFrequency: dataForRegisterFormEval?.riskHierarchy? dataForRegisterFormEval?.riskHierarchy?.riskAdditionalData?.monitoringAndReview?.reviewFrequency  || "" : dataForRegisterFormEval?.riskAdditionalData?.monitoringAndReview?.reviewFrequency  || "",
    lastReviewDate: dataForRegisterFormEval?.riskHierarchy? dataForRegisterFormEval?.riskHierarchy?.riskAdditionalData?.monitoringAndReview?.lastReviewDate  || "" : dataForRegisterFormEval?.riskAdditionalData?.monitoringAndReview?.lastReviewDate  || "",
    nextReviewDate: dataForRegisterFormEval?.riskHierarchy? dataForRegisterFormEval?.riskHierarchy?.riskAdditionalData?.monitoringAndReview?.nextReviewDate  || "" : dataForRegisterFormEval?.riskAdditionalData?.monitoringAndReview?.nextReviewDate  || "",
    KRIs: dataForRegisterFormEval?.riskHierarchy? dataForRegisterFormEval?.riskHierarchy?.riskAdditionalData?.monitoringAndReview?.kris.map((data) => data.keyIndicator)  || [] : dataForRegisterFormEval?.riskAdditionalData?.monitoringAndReview?.kris.map((data) => data.keyIndicator)  || [],
    supportingDocumentation: dataForRegisterFormEval?.riskHierarchy?  dataForRegisterFormEval?.riskHierarchy?.riskAdditionalData?.monitoringAndReview?.supportingDocumentation?.map((data) => data.supportingDocument) || [] : dataForRegisterFormEval?.riskAdditionalData?.monitoringAndReview?.supportingDocumentation?.map((data) => data.supportingDocument) || [],
    revisionHistory: dataForRegisterFormEval?.riskHierarchy?  dataForRegisterFormEval?.riskHierarchy?.riskAdditionalData?.auditTrail  || [] : dataForRegisterFormEval?.riskAdditionalData?.auditTrail  || [],
  });


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "likelihood" || name === "impact") {
      const likelihood = name === "likelihood" ? parseInt(value) || 0 : formData.likelihood;
      const impact = name === "impact" ? parseInt(value) || 0 : formData.impact;
      setFormData({ ...formData, riskLevel: likelihood * impact, [name]: value });
    }
  };

  const handleKRIChange = (index, value) => {
    setFormData({
      ...formData,
      KRIs: formData.KRIs.map((item, i) => (i === index ? value : item)),
    });
  };

  const handleRevisionChange = (index, field, value) => {
    const updatedHistory = [...formData.revisionHistory];
    updatedHistory[index][field] = value;
    setFormData({ ...formData, revisionHistory: updatedHistory });
  };

  const exportToExcel = (tabDataArr) => {
    console.log(tabDataArr);
  
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Risk Register");
  
    const riskData = [];
  
    tabDataArr.forEach((item) => {
      const { value } = item;
      const { riskReference, riskCategory, objectivesAffected } = value.generalInformation;

      riskData.push([" ", riskCategory, ""]);
      riskData.push(["Section name", "Field Name", "Value"]);
      riskData.push([]); 
  
      if (value.generalInformation) {
        riskData.push(["General Information", "Risk Reference", riskReference]);
        riskData.push(["General Information", "Risk Category", riskCategory]);
        riskData.push(["General Information", "Objectives Affected", objectivesAffected]);
        riskData.push([]); 
      }
  
      if (value.assessment) {
        const { riskLikelihood, riskImpact, riskAppetite, riskLevel } = value.assessment;
        riskData.push(["Risk Assessment", "Likelihood", riskLikelihood]);
        riskData.push(["Risk Assessment", "Impact", riskImpact]);
        riskData.push(["Risk Assessment", "Risk Appetite", riskAppetite]);
        riskData.push(["Risk Assessment", "Risk Level", riskLevel]);
        riskData.push([]); 
      }
  
      if (value.currentControls) {
        const { currentControls, controlEffectiveness } = value.currentControls;
        riskData.push(["Current Controls", "Current Controls", currentControls]);
        riskData.push(["Current Controls", "Control Effectiveness", controlEffectiveness]);
        riskData.push([]);
      }
  
      if (value.mitigationActions) {
        const { mitigation, actionOwner, targetCompletionDate, status } = value.mitigationActions;
        riskData.push(["Mitigation Actions", "Mitigation", mitigation]);
        riskData.push(["Mitigation Actions", "Action Owner", actionOwner]);
        riskData.push(["Mitigation Actions", "Target Completion Date", targetCompletionDate]);
        riskData.push(["Mitigation Actions", "Status", status]);
        riskData.push([]); 
      }
  
      if (value.monitoringAndReview) {
        const { reviewFrequency, lastReviewDate, nextReviewDate, kris, supportingDocumentation } = value.monitoringAndReview;
        riskData.push(["Monitoring & Review", "Review Frequency", reviewFrequency]);
        riskData.push(["Monitoring & Review", "Last Review Date", lastReviewDate]);
        riskData.push(["Monitoring & Review", "Next Review Date", nextReviewDate]);
  
        if (kris && kris.length > 0) {
          riskData.push(["Monitoring & Review", "KRIs", kris[0].keyIndicator]);
          for (let i = 1; i < kris.length; i++) {
            riskData.push(["", "", kris[i].keyIndicator]);
          }
        }
  
        if (supportingDocumentation && supportingDocumentation.length > 0) {
          riskData.push([
            "Monitoring & Review",
            "Supporting Documentation",
            supportingDocumentation[0].supportingDocument,
          ]);
          for (let i = 1; i < supportingDocumentation.length; i++) {
            riskData.push(["", "", supportingDocumentation[i].supportingDocument]);
          }
        }
  
        riskData.push([]); 
      }
  
      if (value.auditTrail && value.auditTrail.length > 0) {
        riskData.push(["Audit Trail", "Revision Date", "Revised By", "Changes Made"]);
        value.auditTrail.forEach((audit) => {
          riskData.push([
            "",
            audit.revisionDate.split("T")[0],
            audit.revisedBy,
            audit.changesMade,
          ]);
        });
        riskData.push([]); 
      }
    });
  
  
    riskData.forEach((row) => {
      const newRow = worksheet.addRow(row);
      newRow.eachCell((cell) => {
        cell.alignment = { horizontal: "left" };
  

        if (row[0] === " " && row[2] === "") {

          cell.font = { bold: true, color: { argb: "FF0000FF" } }; 
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFB6D7A8" }, 
          };
        } else if (row[0] === "Section name" && row[1] === "Field Name" && row[2] === "Value") {

          cell.font = { bold: true, color: { argb: "#000000" } }; 
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF9E79F" }, 
          };
        }
      });
    });
  
  
    worksheet.columns = [
      { width: 20 },
      { width: 30 },
      { width: 100 },
    ];
  
 
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `${'allSheets-' + new Date()}.xlsx`);
    });
  };
  
  
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };





  return (
    <>
      <Grid container spacing={1} style={{marginTop: "-17px"}}>
      <Grid item xs={12}>
          <Stack direction="row" spacing={2}
            justifyContent="space-between">
                <div style={{fontWeight: "bold", color:'black'}}>
                  
                </div>
                <div>
                <Button
                variant="contained"
                color="primary"
                style={{fontSize: '9px'}}
                onClick={() => exportToExcel(tabDataArr)}
                >
                Export All to Excel
                </Button>
                </div>
          </Stack>
        </Grid>
       </Grid> 
      <Paper elevation={3} sx={{ width: "100%", borderRadius: 2, overflow: "hidden" }}>
      <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          textColor="secondary"
          indicatorColor="secondary"
          sx={{
            ".MuiTab-root": {
              textTransform: "none",
              fontWeight: "bold",
              fontSize: "16px",
              padding: "12px",
              minWidth: "120px",
            },
            ".Mui-selected": {
              color: "#1976d2",
            },
          }}
        >
          
          {tabDataArr.map((tabData, index) => (
            <Tab
              key={index}
              label={
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ textTransform: "none", width: "200px", height: "40px", padding: '0px' }}
                >
                  {tabData.value.generalInformation.riskCategory}
                </Button>
              }
            />
          ))}
        </Tabs>

        {tabDataArr.map((tabData, index) => (
          <Box
            key={index}
            role="tabpanel"
            hidden={activeTab !== index}
            id={`tabpanel-${index + 1}`}
            aria-labelledby={`tab-${index + 1}`}
            sx={{ p: 3, backgroundColor: "#ffffff", borderRadius: 1 }}
          >
            {activeTab === index  && (
              <RiskRegisterFormForEvaluateSub
                dataForRegisterFormEval={tabData}
                globalCentreId={globalCentreId}
              />
            )}
          </Box>
        ))}


      </Paper>


  </>
  );
};

export default RiskRegisterFormForEvaluate;
